<div class="custom-row">
    @if(!mode) {
        <ppl-button label="Add New Provider Auth" icon="fa fa-plus" [customClass]="'primary-button'" [iconPosition]="'left'"
            (click)="addAllocation('Add')"></ppl-button>
    }
</div>
<div>
    <ppl-list-table [actionButtons]="actionButtons" [actionsDisabler]="actionsDisabler" [cols]="allocationCols"
        [data]="authAllocationData" [disableSort]="true" [disableSearch]="true" [disableSelection]="true"
        [enableActions]="true" (gridAction)="onGridAction($event)" [gridTitle]="false"
        [lineItemCols]="serviceDetailCols" [loadPage]="true" [pagination]="true" [recordsPerPage]="10"
        (rowCellClicked)="onCellClicked($event)" (rowDetailEvent)="onRowExpand($event)" [showExpandIcon]="true"
        [showLineItem]="true" [showLineItemActions]="false">
        <ng-template #rowActions let-rowData="rowData">
            <div class="action-item">
                <div class="action-container">
                    @if(rowData?.actions?.edit) {
                    <ppl-button size="small" label="Edit" icon="fa fa-pencil" [customClass]="'ghost-button'"
                        [iconPosition]="'left'" (click)="onGridAction({ action: 'edit', data: rowData })"></ppl-button>
                    }
                    @if(!mode && rowData?.active) {
                    <ppl-button size="small" label="Add Service Detail" icon="fa fa-plus"
                        [customClass]="'ghost-button'" [iconPosition]="'left'"
                        (click)="openServiceDetailDialog(rowData, null)"></ppl-button>
                    }
                </div>
            </div>
        </ng-template>
    </ppl-list-table>
</div>

<div class="filter-panel">
    <ng-template #authAllocationAddDialog let-cancel="cancel">
        <div class="p-10">
            <form nz-form [formGroup]="addAuthAllocationForm">
                <div nz-row>
                    <div nz-col *ngIf="addAuthAllocationForm.controls['pa']"
                        style="margin-left: 8px; margin-right: 8px;width: 100%;">
                        <nz-form-item>
                            <nz-form-label [nzSm]="10" [nzXs]="24" nzFor="pa" class="ppl-form-label">
                                Provider
                            </nz-form-label>
                            <nz-form-control>
                                <nz-select formControlName="pa" class="filters" id="pa" nzPlaceHolder="Select Provider"
                                    nzShowSearch nzAllowClear="true" style="width: 100%;"
                                    (ngModelChange)="validateProvider($event)"
                                    [nzStatus]="addAuthAllocationForm.get('pa')?.invalid && addAuthAllocationForm.get('pa')?.touched ? 'error' : ''">
                                    <nz-option *ngFor="let opt of providers" [nzLabel]="opt.providerPplId"
                                        [nzValue]="opt.providerId">
                                    </nz-option>
                                </nz-select>

                                <div
                                    *ngIf="addAuthAllocationForm.controls['pa'].errors?.['required'] && addAuthAllocationForm.controls['pa'].touched">
                                    <div nz-form-explain class="error-message">Please select PA.</div>
                                </div>
                                <div
                                    *ngIf="addAuthAllocationForm.controls['pa'].errors?.['customError'] && addAuthAllocationForm.controls['pa'].touched">
                                    <div nz-form-explain class="error-message">
                                        {{addAuthAllocationForm.controls['pa'].errors?.['customError']}}</div>
                                </div>
                            </nz-form-control>
                        </nz-form-item>
                    </div>
                </div>
                <div nz-row>
                    <div nz-col *ngIf="addAuthAllocationForm.controls['authStartDate']"
                        style="margin-left: 8px; margin-right: 8px; width: 100%;">
                        <nz-form-item>
                            <nz-form-label [nzSm]="10" [nzXs]="24" nzFor="authStartDate" class="ppl-form-label">
                                Auth Start Date
                            </nz-form-label>
                            <nz-form-control>
                                <nz-date-picker formControlName="authStartDate" id="authStartDate"
                                    nzPlaceHolder="Auth Start Date" [nzFormat]="'MM/dd/yyyy'" nzAllowClear="false"
                                    style="width: 100%; height: 32px"></nz-date-picker>

                                <div
                                    *ngIf="addAuthAllocationForm.controls['authStartDate'].errors?.['required'] && addAuthAllocationForm.controls['authStartDate'].touched">
                                    <div nz-form-explain class="error-message">Please enter Auth Start Date.</div>
                                </div>
                                <div
                                    *ngIf="addAuthAllocationForm.controls['authStartDate'].errors?.['customError'] && addAuthAllocationForm.controls['authStartDate'].touched">
                                    <div nz-form-explain class="error-message">
                                        {{addAuthAllocationForm.controls['authStartDate'].errors?.['customError']}}
                                    </div>
                                </div>
                            </nz-form-control>
                        </nz-form-item>
                    </div>
                </div>
                <div nz-row>
                    <div nz-col *ngIf="addAuthAllocationForm.controls['authEndDate']"
                        style="margin-left: 8px; margin-right: 8px; width: 100%;">
                        <nz-form-item>
                            <nz-form-label [nzSm]="10" [nzXs]="24" nzFor="authEndDate" class="ppl-form-label">
                                Auth End Date
                            </nz-form-label>
                            <nz-form-control>
                                <nz-date-picker formControlName="authEndDate" id="authEndDate"
                                    nzPlaceHolder="Auth End Date" [nzFormat]="'MM/dd/yyyy'" nzAllowClear="false"
                                    style="width: 100%; height: 32px"></nz-date-picker>

                                <div
                                    *ngIf="addAuthAllocationForm.controls['authEndDate'].errors?.['required'] && addAuthAllocationForm.controls['authEndDate'].touched">
                                    <div nz-form-explain class="error-message">Please enter Auth End Date.</div>
                                </div>
                                <div
                                    *ngIf="addAuthAllocationForm.controls['authEndDate'].errors?.['customError'] && addAuthAllocationForm.controls['authEndDate'].touched">
                                    <div nz-form-explain class="error-message">
                                        {{addAuthAllocationForm.controls['authEndDate'].errors?.['customError']}}</div>
                                </div>
                            </nz-form-control>
                        </nz-form-item>

                    </div>
                </div>
                <div nz-row>
                    <div nz-col *ngIf="addAuthAllocationForm.controls['units']"
                        style="margin-left: 8px; margin-right: 8px; width: 100%;">
                        <nz-form-item>
                            <nz-form-label [nzSm]="10" [nzXs]="24" nzFor="units" class="ppl-form-label">
                                Allocated Dollars
                            </nz-form-label>
                            <nz-form-control>
                                <input formControlName="units" nz-input id="units" placeholder="Allocated Dollars" />

                                <div
                                    *ngIf="addAuthAllocationForm.controls['units'].errors?.['required'] && addAuthAllocationForm.controls['units'].touched">
                                    <div nz-form-explain class="error-message">Please enter Allocated Dollars.</div>
                                </div>
                                <div
                                    *ngIf="addAuthAllocationForm.controls['units'].errors?.['customError'] && addAuthAllocationForm.controls['units'].touched">
                                    <div nz-form-explain class="error-message">
                                        {{addAuthAllocationForm.controls['units'].errors?.['customError']}}
                                    </div>
                                </div>
                            </nz-form-control>
                        </nz-form-item>
                    </div>
                </div>
                <div nz-row>
                    <div nz-col *ngIf="addAuthAllocationForm.controls['otherRate']"
                        style="margin-left: 8px; margin-right: 8px; width: 100%;">
                        <nz-form-item>
                            <nz-form-label [nzSm]="10" [nzXs]="24" nzFor="otherRate" class="ppl-form-label">
                                Other Rate
                            </nz-form-label>
                            <nz-form-control>
                                <label class="switch">
                                    <input type="checkbox" formControlName="otherRate" id="otherRate">
                                    <span class="slider round"></span>
                                </label>
                            </nz-form-control>
                        </nz-form-item>
                    </div>
                </div>
            </form>

            <div class="custom-row">
                <ppl-button label="Submit Provider Allocation" icon="fa fa-check-circle"
                    [customClass]="'primary-button'" [iconPosition]="'left'"
                    (click)="onAuthAllocationActionPerformed(currentAuthorizationProviderId === null ? 'Add' : 'Update')"></ppl-button>
                @if(currentAuthorizationProviderId !== null) {
                <ppl-button label="Deactivate" icon="fa fa-trash" [customClass]="'ghost-button'"
                    [iconPosition]="'left'" (click)="confirmAllocationDeactivation()"></ppl-button>
                }
            </div>
        </div>
    </ng-template>
</div>

<div class="filter-panel">
    <ng-template #serviceDetailDialog let-cancel="cancel">
        <ppl-auth-service-detail-form [serviceDetail]="currentServiceDetail"
            [authorizationProviderId]="currentServiceAllocation?.authorizationProviderId"
            (save)="onServiceDetailSaved($event)"
            (deactivate)="confirmServiceDetailDeactivation()"></ppl-auth-service-detail-form>
    </ng-template>
</div>

<div class="filter-panel">
    <ng-template #confirmationDialog let-cancel="cancel">
        <p>Provider allocation will be deactivated. Do you want to continue?</p>
    </ng-template>
</div>

<div class="filter-panel">
    <ng-template #serviceDetailConfirmationDialog let-cancel="cancel">
        <p>Service detail will be deactivated. Do you want to continue?</p>
    </ng-template>
</div>